// eslint-disable-next-line
const emailRegex = /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export default emailRegex;
